/* ════════════════════════════════════════════════════════════════════════
   OBRIY — Product detail page interactions
   Variant picker, quantity stepper and image gallery for the real Shopify
   product. Add-to-cart itself is handled by the shared cart.js (data-add-form).
   ════════════════════════════════════════════════════════════════════════ */
(function () {
  function init(root) {
    if (!root || root.dataset.pdpReady === "1") return;
    root.dataset.pdpReady = "1";

    var variants = [];
    var prices = {};
    var variantsEl = root.querySelector("[data-pdp-variants]");
    var pricesEl = root.querySelector("[data-pdp-prices]");
    var copyEl = root.querySelector("[data-pdp-copy]");
    var copy = { unavailable: "Unavailable", addToBag: "Add to bag — ", soldOut: "Sold out" };
    try {
      if (variantsEl) variants = JSON.parse(variantsEl.textContent);
    } catch (e) {}
    try {
      if (pricesEl) prices = JSON.parse(pricesEl.textContent);
    } catch (e) {}
    try {
      if (copyEl) copy = JSON.parse(copyEl.textContent);
    } catch (e) {}

    var idInput = root.querySelector("[data-variant-id]");
    var buyBtn = root.querySelector("[data-buy-btn]");
    var priceEl = root.querySelector("[data-buy-price]");
    var lblEl = buyBtn ? buyBtn.querySelector(".lbl") : null;
    var weightEl = root.querySelector("[data-pdp-weight]");
    var groups = Array.prototype.slice.call(root.querySelectorAll(".opt-group[data-option-index]"));
    var grindFormats = Array.prototype.slice.call(root.querySelectorAll("[data-grind-format]"));
    var grindMethod = root.querySelector("[data-grind-method]");
    var grindSelect = root.querySelector("[data-grind-select]");
    var grindFormatDisplay = root.querySelector("[data-grind-format-display]");
    var form = root.querySelector("[data-pdp-form]");

    function selection() {
      var sel = [];
      groups.forEach(function (g) {
        var idx = parseInt(g.getAttribute("data-option-index"), 10);
        var on = g.querySelector(".opt.is-on");
        sel[idx] = on ? on.getAttribute("data-value") : null;
      });
      return sel;
    }

    function matchVariant(sel) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var j = 0; j < v.options.length; j++) {
          if (sel[j] != null && v.options[j] !== sel[j]) {
            ok = false;
            break;
          }
        }
        if (ok) return v;
      }
      return null;
    }

    function updateWeightLabel(v) {
      if (!weightEl || !v || !v.options) return;
      for (var i = 0; i < groups.length; i++) {
        var optionName = groups[i].querySelector(".head span");
        var optionLabel = optionName ? optionName.textContent.trim().toLowerCase() : "";
        if (optionLabel === "weight" || optionLabel === "вага") {
          if (v.options[i]) weightEl.textContent = v.options[i].toUpperCase();
          return;
        }
      }
    }

    function updateGrindMethod() {
      if (!grindMethod || !grindSelect) return;
      var ground = root.querySelector("[data-grind-format-ground]:checked");
      grindMethod.hidden = !ground;
      grindSelect.disabled = !ground;
      grindSelect.required = !!ground;
      if (!ground) grindSelect.value = "";
      var selected = root.querySelector("[data-grind-format]:checked");
      if (grindFormatDisplay && selected) {
        grindFormatDisplay.textContent = selected.value;
      }
      grindFormats.forEach(function (input) {
        var label = input.closest(".opt");
        if (label) label.classList.toggle("is-on", input.checked);
      });
    }

    function update() {
      var v = groups.length ? matchVariant(selection()) : variants[0];
      if (!v) {
        if (buyBtn) buyBtn.disabled = true;
        if (lblEl) lblEl.textContent = copy.unavailable;
        if (priceEl) priceEl.textContent = "";
        return;
      }
      if (idInput) idInput.value = v.id;
      updateWeightLabel(v);
      if (v.available) {
        if (buyBtn) {
          buyBtn.disabled = !!(
            (grindSelect && grindSelect.required && !grindSelect.value) ||
            (form && form.dataset.addPending === "1")
          );
        }
        if (lblEl) lblEl.textContent = copy.addToBag;
        if (priceEl) priceEl.textContent = prices[v.id] || "";
      } else {
        if (buyBtn) buyBtn.disabled = true;
        if (lblEl) lblEl.textContent = copy.soldOut;
        if (priceEl) priceEl.textContent = "";
      }
    }

    root.addEventListener("click", function (e) {
      var brewLink = e.target.closest("[data-brew-scroll]");
      if (brewLink) {
        var brewSection = document.getElementById(brewLink.hash.slice(1));
        if (brewSection) {
          e.preventDefault();
          brewSection.focus({ preventScroll: true });
          brewSection.scrollIntoView({
            behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches
              ? "instant"
              : "smooth",
            block: "start",
          });
        }
        return;
      }

      var chip = e.target.closest(".opt[data-opt-value]");
      if (chip) {
        var g = chip.closest(".opt-group");
        g.querySelectorAll(".opt").forEach(function (b) {
          b.classList.toggle("is-on", b === chip);
        });
        var disp = g.querySelector("[data-opt-display]");
        if (disp) disp.textContent = chip.getAttribute("data-value");
        update();
        return;
      }

      var dec = e.target.closest("[data-qty-dec]");
      var inc = e.target.closest("[data-qty-inc]");
      if (dec || inc) {
        var qIn = root.querySelector("[data-qty-input]");
        var qVal = root.querySelector("[data-qty-val]");
        var q = parseInt(qIn.value, 10) || 1;
        q = dec ? Math.max(1, q - 1) : Math.min(99, q + 1);
        qIn.value = q;
        if (qVal) qVal.textContent = q;
        return;
      }

      var thumb = e.target.closest("[data-gallery-thumb]");
      if (thumb) {
        var main = root.querySelector("[data-gallery-main]");
        if (main) {
          main.src = thumb.getAttribute("data-src");
          var ss = thumb.getAttribute("data-srcset");
          if (ss) main.srcset = ss;
          var alt = thumb.getAttribute("data-alt");
          if (alt) main.alt = alt;
        }
        root.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
          t.classList.toggle("is-current", t === thumb);
        });
        return;
      }
    });

    root.addEventListener("change", function (e) {
      if (e.target.matches("[data-grind-format]")) {
        updateGrindMethod();
        update();
        return;
      }
      if (e.target.matches("[data-grind-select]")) update();
    });

    root.addEventListener("cart:add:complete", update);
    updateGrindMethod();
    update();
  }

  function boot() {
    document.querySelectorAll("[data-pdp]").forEach(init);
  }

  document.addEventListener("DOMContentLoaded", boot);
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-pdp]");
    if (root) {
      root.dataset.pdpReady = "";
      init(root);
    }
  });
})();
